import gql from 'graphql-tag';

const GET_SPECIAL_NOTES = gql`
  query getSpecialNotes($query: JSON) {
    getSpecialNotes(query: $query)
  }
`;

export default GET_SPECIAL_NOTES;
